import {FormControl, TextField} from '@material-ui/core';
import {TextFieldProps} from '@material-ui/core/TextField';
import React, {ReactNode} from 'react';
import {SelectProps} from '@material-ui/core/Select';

type OutlinedSelectProps = {
  children: ReactNode;
  label: string;
  className?: string;
  multiple?: boolean;
  renderValue?: SelectProps['renderValue'];
} & TextFieldProps;

const OutlinedSelect = (props: OutlinedSelectProps) => {
  return (
    <FormControl className={props.className} variant="outlined">
      <TextField
        SelectProps={{
          multiple: props.multiple,
          renderValue: props.renderValue,
        }}
        select
        {...props}
        label={props.label}
        variant="outlined"
        value={props.value}
        onChange={props.onChange}
        className=""
      >
        {props.children}
      </TextField>
    </FormControl>
  );
};

export default OutlinedSelect;
